import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { ISubCategoryContext, SubCategoryContext } from '../../../../subCategoryState/subCategoryContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { subCategories } = useContext<ISubCategoryContext>(SubCategoryContext);

	const subCategoryHeadingClasses = classNames(style.subCategory, style.heading);
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const positionHeadingClasses = classNames(style.position, style.heading);
	const isHiddenHeadingClasses = classNames(style.isHidden, style.heading);
	const availableForRepetitionClasses = classNames(style.availableForRepetition, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={subCategoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="subcategoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={positionHeadingClasses}
					translationNameSpace="listing"
					translationKey="positionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isHiddenHeadingClasses}
					translationNameSpace="listing"
					translationKey="isHiddenLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={availableForRepetitionClasses}
					translationNameSpace="listing"
					translationKey="availableForRepetitionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{subCategories.subCategories.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};

export default List;
